/** Preference for whether the auth session survives closing the tab. */
const REMEMBER_SESSION_KEY = 'studycharm-remember-session';

function read(storage: Storage, key: string): string | null {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

function write(storage: Storage, key: string, value: string): void {
  try {
    storage.setItem(key, value);
  } catch {
    // Private mode / quota — session just won't persist.
  }
}

function remove(storage: Storage, key: string): void {
  try {
    storage.removeItem(key);
  } catch {
    // ignore
  }
}

/** Default is remember: closing the tab should not sign the user out. */
export function getRememberSession(): boolean {
  return read(window.localStorage, REMEMBER_SESSION_KEY) !== '0';
}

export function setRememberSession(remember: boolean): void {
  write(window.localStorage, REMEMBER_SESSION_KEY, remember ? '1' : '0');
}

/**
 * Persist the Supabase session in localStorage (remember) or sessionStorage
 * (this tab only). Reads from both so an existing login still restores.
 */
export const authStorage = {
  getItem(key: string): string | null {
    return read(window.localStorage, key) ?? read(window.sessionStorage, key);
  },
  setItem(key: string, value: string): void {
    if (getRememberSession()) {
      write(window.localStorage, key, value);
      remove(window.sessionStorage, key);
    } else {
      write(window.sessionStorage, key, value);
      remove(window.localStorage, key);
    }
  },
  removeItem(key: string): void {
    remove(window.localStorage, key);
    remove(window.sessionStorage, key);
  },
};
